import React from 'react'
import {removeZeros} from '../../../utils/misc'


export class BarCodeInput extends React.Component {

  constructor() {
    super()
    this.state = {value:''}

  }

  static defaultProps = {maxDelay:10000}
  componentWillReceiveProps(nextProps) {
   if (nextProps.item !== this.props.item) {
     //Forcibly overwrite input value to new default if the default ever changes

     let item = nextProps.item

     if(item && item.serial > 0) {
       if(item && item.extra) {
          let extra = item.extra
          this.setState({value:extra[this.props.name]})
       }
       else {
         this.setState({value:''})
       }

     }
     else {
       this.setState({value:''})
     }
   }
 }

 componentDidMount() {
   let item = this.props.item
   if(item && item.serial > 0) {
     if(item && item.extra) {
        let extra = item.extra
        this.setState({value:extra[this.props.name]})
     }

   }
 }
 lastTime = 0
 handleInputChange = (e) => {
   const { maxDelay } = this.props
   const now = Date.now()
   const delay = now - this.lastTime
   const value = e.target.value

   if (delay <= maxDelay || this.lastTime === 0) {
     this.setState(() => ({
       value: value
     }))

     this.lastTime = now
     setTimeout(() => {
       if (this.state.value.length < 2) this.clearValue()
     }, maxDelay * 2)

     return null
   }

   if (delay > maxDelay) this.clearValue()
 }

 clearValue = () => {
   this.setState(() => ({
     value: ''
   }))
   this.resetLastTime()
 }

 handleInputKeyUp = (e) => {
   const keyCode = e.keyCode
   if (keyCode === 8) {
     this.setState({
       value: ''
     })

     this.resetLastTime()
   }

   if (keyCode === 13) {
     // Handle Enter
     console.log(this.state.value);
     let item = this.props.item
     let extra = item.extra
     if(!extra) {
       extra = {}
     }
     extra[this.props.name] = this.state.value
     item.extra = extra

     // var evt = new KeyboardEvent('keydown', {key:'Tab',
     //        bubbles:true})
     // document.dispatchEvent (evt);


     this.props.onChangeCallback(item)
     this.resetLastTime()
     if(this.props.next_focus) {
       let next_id = this.props.next_focus
       if(this.props.item) {
         next_id = next_id + this.props.item.tableIndex
       }
        document.getElementById(next_id).focus()
     }
   }
 }

 resetLastTime = () => {
   this.lastTime = 0
   this.input.select()
 }

 render() {
   const { value } = this.state
   let id = this.props.name
   if(this.props.item) {
     id = id + this.props.item.tableIndex
   }
   return (
     <div>
       <input className="form-control" placeholder={this.props.name} autofocus
         ref={input => this.input = input} id={id}
         value={value}
         onChange={this.handleInputChange}
         onKeyUp={this.handleInputKeyUp}
       />
     </div>
   );
 }

}

export class SaveInvoiceBtn extends React.Component {

  render() {
    if(this.props.working) {
      return <button className="btn btn-primary" disabled>Saving...</button>
    }
    else {
      return <button className="btn btn-primary" onClick={(e)=>{this.props.handleSaveInvoice(e)}}>Save Invoice</button>
    }
  }
}

export class AddInvoiceRow extends React.Component {

  render() {
    return <button className="btn btn-info btn-sm" onClick={(e)=>{this.props.handleAddRow(e)}}>Add Row</button>
  }
}

export class Hsn extends React.Component {
  render(){

    return <div className="text-vcenter-sm">{this.props.item.hsn}</div>
  }
}

export class Price extends React.Component {
  render() {
    return <div className="text-vcenter-sm">{removeZeros(this.props.item.price)}</div>
  }
}

export class Tax extends React.Component {
  render() {
    return <input tabIndex="-1" type="number" name="tax" step=".01" className="form-control input-sm "  value={this.props.item.tax}  readOnly/>
  }
}


export class Cgst extends React.Component {
  render() {

    let item = this.props.item
    let inputValue = this.props.item.cgst_amount
    if(typeof item.gst !== "undefined" && item.gst !== null && typeof item.gst.cgst !== "undefined") {
       inputValue = Number(inputValue) + " (" + Number(item.gst.cgst) + "%)"
    }
    return <div className="text-vcenter-sm">{inputValue}</div>
    //return <input tabIndex="-1" type="text" name="cgst" step=".01" className="form-control input-sm "  value={inputValue}  readOnly/>
  }
}
export class Sgst extends React.Component {
  render() {
    let item = this.props.item
    let inputValue = this.props.item.sgst_amount
    if(typeof item.gst !== "undefined" && item.gst !== null && typeof item.gst.sgst !== "undefined") {
       inputValue = Number(inputValue) + " (" + Number(item.gst.cgst) + "%)"
    }
    return <div className="text-vcenter-sm">{inputValue}</div>
  }
}
export class Igst extends React.Component {
  render() {
    let item = this.props.item
    let inputValue = this.props.item.igst_amount
    if(typeof item.gst !== "undefined" && item.gst !== null && typeof item.gst.igst !== "undefined") {
       inputValue = Number(inputValue) + " (" + Number(item.gst.igst) + "%)"
    }
    return <div className="text-vcenter-sm">{inputValue}</div>
  }
}

export class Total extends React.Component {
  render() {
    var total = parseFloat(this.props.item.total)
    return <div className="text-vcenter-sm">{total}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/rowelements/others.js